import actions from './actions';
import middleware from './middleware';

export default {
  actions,
  middleware,
};
